// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"438":"15b6feb1218c3727","491":"b58b54f829ec8ead"}[chunkId] + ".js";
};